import { render, staticRenderFns } from "./CoverSection.vue?vue&type=template&id=b18c7004"
import script from "./CoverSection.vue?vue&type=script&lang=js"
export * from "./CoverSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports